<template>
  <a-checkbox-group v-if="tagType=='checkbox'" @change="onChange" :value="arrayValue" :disabled="disabled">
    <a-checkbox v-for="(item, key) in dictOptions" :key="key" :value="item.value">{{ item.text || item.label }}
    </a-checkbox>
  </a-checkbox-group>


  <a-select v-bind="$attrs" v-else-if="tagType=='select'" :value="arrayValue" @change="onChange"
    :maxTagCount="maxTagCount" :maxTagTextLength="3" :disabled="disabled" mode="multiple" :placeholder="placeholder"
    allowClear>
    <a-select-option v-for="(item,index) in dictOptions" :key="index" :value="item.value" :disabled="item.forbidden">
      <span style="display: inline-block;width: 100%" :title=" item.text || item.label ">
        {{ item.text || item.label }}
      </span>
    </a-select-option>
  </a-select>

</template>

<script>
  import {
    ajaxGetDictItems,
    ajaxcategory
  } from '@/api/api'
  export default {
    name: 'JMultiSelectTag',
    props: {
      dictCode: String,
      placeholder: String,
      disabled: Boolean,
      value: String,
      type: String,
      options: Array,
      maxTagCount: Number
    },
    data() {
      return {
        dictOptions: [],
        tagType: "",
        arrayValue: !this.value ? [] : this.value.split(",")
      }
    },
    mounted() {
      if (!this.type || this.type === "list_multi") {
        this.tagType = "select"
      } else {
        this.tagType = this.type
      }

      if (localStorage.getItem("report")) {
        this.report()
      } else {
        //   //获取字典数据
        this.initDictData();
      }
    },
    watch: {
      options: function (val) {
        this.setCurrentDictOptions(val);
      },
      value(val) {
        if (!val) {
          this.arrayValue = []
        } else {
          this.arrayValue = this.value.split(",")
        }
      }
    },
    methods: {
      report() {
        ajaxcategory(this.dictCode, null).then((res) => {
          if (res.success) {
            this.dictOptions = res.result
          }
        })
      },
      initDictData() {
        if (this.options && this.options.length > 0) {
          this.dictOptions = [...this.options]
        } else {
          if(this.dictCode){
            //根据字典Code, 初始化字典数组
            ajaxGetDictItems(this.dictCode, null).then((res) => {
              if (res.success) {
                this.dictOptions = res.result;
              }
            })
          }

        }

      },
      onChange(selectedValue) {
        this.$emit('change', selectedValue.join(","));
      },
      setCurrentDictOptions(dictOptions) {
        this.dictOptions = dictOptions
      },
      getCurrentDictOptions() {
        return this.dictOptions
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>